module.exports = __webpack_public_path__ + "static/img/cpzx_nav_4@2x.cd4ac1bd.png";